<!--
  @Author: MIYONGLE
  @Desc: 消息通知,
  @Date: 2022-04-18
-->

<template>
  <div class="right-notice-part">
    <div class="title el-badge-title">
      <el-badge :value="resNumberUnreadMessages" :max="99">
        <span class="tab-text notice-text">消息通知</span>
      </el-badge>
      <span class="notice-more" @click="jumpToPage('/noticeList', '')">
        前往通知中心<i class="el-icon-d-arrow-right"></i>
      </span>
    </div>

    <div class="notice-list">
      <div v-if="resNoticeList.length !== 0">
        <div
          class="notice-item"
          @click="jumpToPage('/noticeListDetail', item.id)"
          v-for="item of resNoticeList"
          :key="item.id"
        >
          <div class="notice-title">
            <div class="left-div">
              <img
                src="../../static/home/icon_basic_news_normal.png"
                v-if="item.redMark == 0"
              />
              <img
                src="../../static/home/icon_basic_news_important.png"
                v-else
              />
              <span>{{ item.noticeName }}</span>
            </div>

            <span>{{ item.createTime }}</span>
          </div>
        </div>
      </div>

      <div class="empty-text" v-else>
        <img src="../../static/home/img_home_news_empty.png" />
        <!-- <span>暂无消息通知~</span> -->
        <span>你已查看所有消息</span>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CODE } from "../../build/axios_constants";
import { PAGINATION } from "../service/businessConsts";
import { getLocal, checkNull } from "./../filters/filters";
export default {
  data() {
    return {
      pagination: PAGINATION,
      resNoticeList: [],
      paramQueryTemp: {
        pageNum: 1,
        pageSize: PAGINATION.pageSize
      },
      resNumberUnreadMessages: 0
    };
  },

  created() {
    this.xhrNoticeList();
    this.xhrGetNumberUnreadMessages();
  },

  methods: {
    // xhr -- 消息列表
    xhrNoticeList() {
      this.$http.postNoticeList(this.paramQueryTemp).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          for (let item of res.data.list) {
            item.createTime = item.createTime.substr(5, 5);
          }

          let resNoticeListTemp = [];
          if (res.data.list.length != 0) {
            res.data.list.forEach(item => {
              if (item.readingStatus === "未读") {
                resNoticeListTemp.push(item);
              }
            });
          }
          this.resNoticeList = resNoticeListTemp;
        }
      });
    },

    // xhr -- 消息通知未读数量
    xhrGetNumberUnreadMessages() {
      this.$http.getNumberUnreadMessages(this.paramQueryTemp).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resNumberUnreadMessages = res.data;
        }
      });
    },

    // 跳转页面
    jumpToPage(path, data) {
      if (data) {
        this.$router.push({ path: path, query: { noticeId: data } });
      } else {
        this.$router.push({ path: path });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
  box-sizing: border-box;
  .tab-text {
    color: #8c8c8c;
    text-align: center;
    font-size: 16px;
    width: 80px;
    display: inline-block;
    margin-left: 40px;
    cursor: pointer;
  }
  .notice-text {
    color: #272727;
    margin-left: 32px;
    cursor: auto;
    // width: 100px;
    text-align: left;
  }
  .active {
    color: #272727;
    border-bottom: 4px solid #1a85ff;
  }
  .notice-more {
    margin-right: 32px;
    font-size: 14px;
    color: #1985ff;
    float: right;
    cursor: pointer;
  }
}

.left-tab-part,
.right-notice-part {
  background-color: #ffffff;
  border-radius: 2px;
}

.left-tab-part {
  width: 63%;
  .title {
    width: 100%;
  }
  .able-balance {
    font-size: 30px;
    color: #ff943e;
    padding: 29px 0 29px 32px;
  }
  .margin-bg {
    height: 16px;
  }

  .recharge-acc-info {
    padding-top: 24px;
    display: flex;
    div {
      width: 50%;
      padding-left: 32px;
      span {
        display: inline-block;
        margin-bottom: 16px;
        color: #595959;
      }

      .value-info-color {
        font-style: normal;
        color: #f2503d;
      }

      .lable-info {
        color: #272727;
      }
    }
  }

  .content {
    padding: 24px 32px 0;
    display: flex;
    justify-content: space-between;
    .item {
      border: 1px solid #eeeeee;
      border-radius: 10px;
      width: 48%;
      height: 180px;
      padding: 32px 24px 0;
      font-size: 14px;
      cursor: pointer;
      .item-top {
        padding-bottom: 32px;
        display: flex;
        justify-content: space-between;
        div {
          width: 62.5%;
        }
        span {
          display: inline-block;
          width: 100%;
        }
        span:nth-child(1) {
          height: 20px;
          line-height: 20px;
          color: #595959;
          margin-bottom: 18px;
          width: 56px;
          border-bottom: 10px solid #e6f1ff;
        }
        span:nth-child(2) {
          height: 30px;
          line-height: 30px;
          font-size: 24px;
          color: #323232;
        }
      }

      .item-bottom {
        height: 47px;
        line-height: 47px;
        border-top: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        span {
          color: #595959;
        }
      }
    }
  }
}

.right-notice-part {
  width: 35%;
  .title {
    width: 100%;
  }

  .tab-text-icon {
    background: #d40000;
    border-radius: 50%;
    color: #fff;
    padding-left: 3px;
    padding-right: 4px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }

  .notice-list {
    padding: 0 32px;
    margin-bottom: 12px;
    overflow-y: hidden;
    max-height: 240px;
    margin-top: 24px;
    .empty-text {
      font-size: 14px;
      width: 100%;
      text-align: center;
      img {
        width: 88px;
        height: 83px;
        display: block;
        text-align: center;
        margin: auto;
        margin-top: 43px;
      }
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 16px;
        display: block;
        text-align: center;
      }
    }

    .notice-item {
      font-size: 14px;
      margin-bottom: 14px;
      cursor: pointer;
      .notice-title {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 26px;
        div.left-div {
          display: flex;
          justify-content: flex-start;
          width: 85%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            color: #272727;
            // position: relative;
            // top: 2px;
            text-align: left;
            margin-left: 8px;
          }
          img {
            width: 26px;
            height: 26px;
          }
        }

        span {
          text-align: right;
          width: 48px;
          margin-left: 8px;
          color: #8c8c8c;
        }
      }

      .notice-detail {
        height: 20px;
        margin-left: 28px;
        padding-right: 32px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notice-list.vue